'use strict';

exports.__esModule = true;
exports.default = getCurrentHref;

var _canUseDom = require('can-use-dom');

var _canUseDom2 = _interopRequireDefault(_canUseDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCurrentHref() {
  if (!_canUseDom2.default) {
    return 'http://www.facebook.com';
  }

  return location.href;
}


//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/react-facebook/lib/utils/getCurrentHref.js
// module id = 108
// module chunks = 0